<template lang="html">
  <div class="product productSuitcase">

    <div class="productImage" href="">

      <div class="overlayImage"></div>

      <div class="imageContent">

        <div class="flag">
          <p class="tag">Alta</p>

        </div>

        <img v-if="dataLuggage.attributes.luggage_type.attributes.key==1" src="https://i.ibb.co/mSQZTM9/maleta-De-Mano.jpg" alt="">
        <img v-if="dataLuggage.attributes.luggage_type.attributes.key==2" src="https://i.ibb.co/CJhVtQ0/maleta.jpg" alt="">
        <img v-if="dataLuggage.attributes.luggage_type.attributes.key==3" src="https://i.ibb.co/pZYJLpy/mochila.jpg" alt="">
        <img v-if="dataLuggage.attributes.luggage_type.attributes.key==4" src="https://i.ibb.co/K6T2hWp/box.png" alt="">

      </div>

    </div>

    <div class="product-content">

      <div class="product-etiquetas-price">


        <div class="price">

          <span class="price-after">
              <span class="bold">{{dataLuggage.attributes.luggage_type.attributes.name +' -'+ dataLuggage.numeration}}  </span></br>
              <span class="bold">{{dataLuggage.attributes.weight}} Kg</span>

          </span>

              <h3 class="productName">{{dataLuggage.attributes.description}}</h3>

        </div>

      </div>


    </div>

  </div>
</template>

<script>

export default {
  props:[
    'dataLuggage'
  ],
  data(){
    return{
    }
  }
}
</script>



// WEBPACK FOOTER //
// card-detail-luggage.vue?2f3c5c0a